import { UUID } from "crypto";
import { baseApi } from "./baseApi";
import { AddressInfo } from "@interfaces/address";
import { Response, ResponsePagination } from "@interfaces/response";

const addressApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        // getAddress: build.query<AddressInfo, { clientDetailsId: UUID; addressTypeId: UUID }>({
        //     query: ({ clientDetailsId, addressTypeId }) => ({
        //         url: `direcciones?q=client_details_id:${clientDetailsId}&q=address_type_id:${addressTypeId}`,
        //     }),
        //     transformResponse: (response: ResponsePagination<AddressInfo>) => {
        //         return response.data.data[0];
        //     },
        // }),
        getAddresses: build.query<Array<AddressInfo>, string>({
            query: (params) => ({
                url: `direcciones?${params}`,
            }),
            transformResponse: (response: ResponsePagination<AddressInfo>) => {
                return response.data.data;
            },
        }),
        postAddress: build.mutation<AddressInfo, any>({
            query: (body) => ({
                url: `direcciones`,
                method: "POST",
                body: body,
            }),
            transformResponse: (response: Response<AddressInfo>) => {
                return response.data;
            },
        }),
        getAddress: build.query<AddressInfo, UUID>({
            query: (addressId) => ({
                url: `direcciones/${addressId}`,
            }),
            transformResponse: (response: Response<AddressInfo>) => {
                return response.data;
            },
        }),
        patchAddress: build.mutation<AddressInfo, { addressId: UUID; body: any }>({
            query: ({ addressId, body }) => ({
                url: `direcciones/${addressId}`,
                method: "PATCH",
                body: body,
            }),
            transformResponse: (response: Response<AddressInfo>) => {
                return response.data;
            },
        }),
        deleteAddress: build.mutation<any, UUID>({
            query: (addressId) => ({
                url: `direcciones/${addressId}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useLazyGetAddressQuery,
    useGetAddressQuery,
    useLazyGetAddressesQuery,
    usePostAddressMutation,
    usePatchAddressMutation,
    useDeleteAddressMutation,
} = addressApi;
